<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="盘号">
          <a-select
            showSearch
            allowClear
            :filterOption="filterOption"
            placeholder="请选择盘号"
            v-decorator="[ 'appSsid', validatorRules.appSsid]">
            <a-select-option v-for="item in appList" :value="item.appssid" :key="item.appssid">{{ item.appName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="第三方">
          <a-select
            showSearch
            allowClear
            :filterOption="filterOption"
            placeholder="请选择第三方"
            v-decorator="[ 'thirdParty', validatorRules.thirdParty]">
            <a-select-option v-for="item in thirdList" :value="item.thirdParty" :key="item.id">{{ item.thirdName || item.thirdParty }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态">
          <a-select v-decorator="[ 'status', validatorRules.status]" :disabled="isGlobalRow">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2">关闭</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addAppThird, editAppThird, getThirdAll } from '@/webpublicapi/third'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'

export default {
  name: 'AppThirdModal',
  data () {
    return {
      title: '操作',
      visible: false,
      model: {},
      // app_ssid='0'(全盘号兜底)的全局行：状态恒为启用，不允许编辑
      isGlobalRow: false,
      appList: [],
      thirdList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appSsid: { rules: [{ required: true, message: '请选择盘号!' }] },
        thirdParty: { rules: [{ required: true, message: '请选择第三方!' }] },
        status: { rules: [{ required: true, message: '请选择状态!' }], initialValue: 1 }
      }
    }
  },
  created () {
    this.loadAppList()
    this.loadThirdList()
  },
  methods: {
    loadAppList () {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项，前插 '0' 兜底项（本表 '0' 为合法配置：全盘号）
          this.appList = [{ appssid: '0', appName: '0-全部盘号' }]
            .concat((res.data || []).filter(item => item.appssid !== ''))
        }
      })
    },
    loadThirdList () {
      getThirdAll().then(res => {
        if (res.code === 1000) {
          this.thirdList = res.data
        }
      })
    },
    filterOption (inputValue, option) {
      return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
    },
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.isGlobalRow = this.model.appSsid === '0'
      // 全局行状态强制回填启用，提交时也恒为 1
      if (this.isGlobalRow) {
        this.model.status = 1
      }
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appSsid', 'thirdParty', 'status'))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          if (!this.model.id) {
            obj = addAppThird(formData)
          } else {
            obj = editAppThird(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
